import { render, staticRenderFns } from "./explainCreat.vue?vue&type=template&id=37e47381&scoped=true"
import script from "./explainCreat.vue?vue&type=script&lang=js"
export * from "./explainCreat.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e47381",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37e47381')) {
      api.createRecord('37e47381', component.options)
    } else {
      api.reload('37e47381', component.options)
    }
    module.hot.accept("./explainCreat.vue?vue&type=template&id=37e47381&scoped=true", function () {
      api.rerender('37e47381', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user/components/explainCreat.vue"
export default component.exports